import { INGREDIENT_KEYWORD_TYPES } from '../../constants'
import { buildIngredientKeywordTree } from '../../helpers'

const transformIngredientKeywordToInitialState = ingredient => ({
  synonyms: buildIngredientKeywordTree({
    keywordTree: [
      {
        id: 0,
        term: INGREDIENT_KEYWORD_TYPES.SYNONYMS.term,
        type: INGREDIENT_KEYWORD_TYPES.SYNONYMS.id,
        children: ingredient.synonyms,
      },
    ],
    keywordType: INGREDIENT_KEYWORD_TYPES.SYNONYMS,
  }),
  varieties: buildIngredientKeywordTree({
    keywordTree: [
      {
        id: 0,
        term: INGREDIENT_KEYWORD_TYPES.VARIETIES.term,
        type: INGREDIENT_KEYWORD_TYPES.VARIETIES.id,
        children: ingredient.varieties,
      },
    ],
    keywordType: INGREDIENT_KEYWORD_TYPES.VARIETIES,
  }),
  discarded: buildIngredientKeywordTree({
    keywordTree: [
      {
        id: 0,
        term: INGREDIENT_KEYWORD_TYPES.DISCARDED.term,
        type: INGREDIENT_KEYWORD_TYPES.DISCARDED.id,
        children: ingredient.discarded,
      },
    ],
    keywordType: INGREDIENT_KEYWORD_TYPES.DISCARDED,
  }),
  uncategorized: buildIngredientKeywordTree({
    keywordTree: [
      {
        id: 0,
        term: INGREDIENT_KEYWORD_TYPES.UNCATEGORIZED.term,
        type: INGREDIENT_KEYWORD_TYPES.UNCATEGORIZED.id,
        children: ingredient.uncategorized,
      },
    ],
    keywordType: INGREDIENT_KEYWORD_TYPES.UNCATEGORIZED,
  }),
})

export default transformIngredientKeywordToInitialState
